import { ArrowLeft, BookOpen, Filter, Search, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';
import PhoneShot from '../ui/PhoneShot';
import { APP_SCREENS } from '../../appScreens';

const points = [
    { icon: Search, text: 'جست‌وجو با نام غذا یا برچسب' },
    { icon: Filter, text: 'فیلتر بر اساس دسته، ماده اصلی، رژیم و روش پخت' },
    { icon: Sparkles, text: 'هر روز دستورهای تازه اضافه می‌شود' },
];

const Cookbook = () => (
    <section id="cookbook" className="section cookbook-section">
        <div className="site-container cookbook-grid">
            <div className="cookbook-copy">
                <div className="eyebrow saffron"><BookOpen size={17} /> کتاب آشپزی هوش‌پز</div>
                <h2>از کتاب آشپزی هوش‌پز الهام بگیر.</h2>
                <p>
                    از کوفته انار و گردو تا پیتزای خانگی؛ دستورهای منتخب با عکس، مواد و مراحل کامل،
                    هم داخل اپ و هم همین‌جا در سایت، بدون نیاز به ثبت‌نام.
                </p>
                <ul className="cookbook-points">
                    {points.map(({ icon: Icon, text }) => (
                        <li key={text}><span><Icon size={18} /></span>{text}</li>
                    ))}
                </ul>
                <Link className="button" to="/recipes">دیدن دستور پخت‌ها <ArrowLeft size={19} /></Link>
            </div>
            <div className="cookbook-visual">
                <div className="cookbook-ring" aria-hidden="true" />
                <PhoneShot screen={APP_SCREENS.cookbook} />
            </div>
        </div>
    </section>
);

export default Cookbook;
